import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const listResumes = ({ skip = 0, limit = 20, q = "" } = {}) => {
  const params = new URLSearchParams();
  params.set("skip", String(skip));
  params.set("limit", String(limit));
  if (q) params.set("q", q);
  return api.get(`/resumes?${params.toString()}`).then((r) => r.data);
};

export const getResume = (id) => api.get(`/resumes/${id}`).then((r) => r.data);
export const deleteResume = (id) => api.delete(`/resumes/${id}`).then((r) => r.data);
export const updateResume = (id, payload) =>
  api.put(`/resumes/${id}`, payload).then((r) => r.data);

export const resummarizeResume = (id) =>
  api.post(`/resumes/${id}/resummarize`).then((r) => r.data);

export const uploadResume = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/resumes/upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const bulkUploadResumes = (files) => {
  const fd = new FormData();
  files.forEach((f) => fd.append("files", f));
  return api
    .post("/resumes/bulk-upload", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const getAppSettings = () => api.get("/settings").then((r) => r.data);
export const updateAppSettings = (payload) =>
  api.put("/settings", payload).then((r) => r.data);

export const listTemplates = () => api.get("/templates").then((r) => r.data);

export const uploadLogo = (file) => {
  const fd = new FormData();
  fd.append("file", file);
  return api
    .post("/settings/logo", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};

export const deleteLogo = () => api.delete("/settings/logo").then((r) => r.data);

export const logoUrl = (cacheBust = "") =>
  `${API}/settings/logo${cacheBust ? `?t=${cacheBust}` : ""}`;

export const pdfUrl = (id, opts = {}) => {
  const params = new URLSearchParams();
  if (opts.anonymize) params.set("anonymize", "true");
  if (opts.showBullets === false) params.set("show_bullets", "false");
  if (opts.template) params.set("template", opts.template);
  const qs = params.toString();
  return `${API}/resumes/${id}/pdf${qs ? `?${qs}` : ""}`;
};
export const docxUrl = (id, opts = {}) => {
  const params = new URLSearchParams();
  if (opts.anonymize) params.set("anonymize", "true");
  if (opts.showBullets === false) params.set("show_bullets", "false");
  if (opts.template) params.set("template", opts.template);
  const qs = params.toString();
  return `${API}/resumes/${id}/docx${qs ? `?${qs}` : ""}`;
};
export const csvExportUrl = () => `${API}/resumes/export.csv`;

// ============ Share links ============
export const createShare = (id, { days = 7, anonymize = false } = {}) =>
  api.post(`/resumes/${id}/share`, { days, anonymize }).then((r) => r.data);

export const listShares = (id) =>
  api.get(`/resumes/${id}/shares`).then((r) => r.data);

export const revokeShare = (token) =>
  api.delete(`/share/${token}`).then((r) => r.data);

export const getSharedResume = (token) =>
  api.get(`/share/${token}`).then((r) => r.data);

export const sharedPdfUrl = (token, opts = {}) => {
  const params = new URLSearchParams();
  if (opts.showBullets === false) params.set("show_bullets", "false");
  if (opts.template) params.set("template", opts.template);
  const qs = params.toString();
  return `${API}/share/${token}/pdf${qs ? `?${qs}` : ""}`;
};
export const sharedDocxUrl = (token, opts = {}) => {
  const params = new URLSearchParams();
  if (opts.showBullets === false) params.set("show_bullets", "false");
  if (opts.template) params.set("template", opts.template);
  const qs = params.toString();
  return `${API}/share/${token}/docx${qs ? `?${qs}` : ""}`;
};

export const buildShareUrl = (token) =>
  `${window.location.origin}/share/${token}`;
